import React from 'react';
import PanelSection from 'components/v2/PanelSection';
import classnames from 'classnames';
export default function CardHeader({ title, className, children, dataTestId = 'card-header', }) {
    return (React.createElement(PanelSection, { dataTestId: dataTestId, className: classnames(className) },
        React.createElement("div", { "data-testid": "div-a3e2a82d", className: "flex items-center justify-between" },
            React.createElement("h3", { "data-testid": "h3-f93bea4f" }, title),
            children)));
}
